import axios from "axios";
import { ArrowRight, Check, Heart } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Skeleton } from "@/components/ui/skeleton";

import { FERRAMENTAS } from "./ferramentas";

const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } });

function Cartao({ f, estado, aoAbrir }) {
  const Icone = f.icone;
  return (
    <button type="button" onClick={aoAbrir} data-e2e={`card-fidelize-${f.id}`}
      className="group text-left bg-card rounded-2xl border overflow-hidden transition-all hover:shadow-lg hover:-translate-y-0.5 hover:border-primary/40 flex flex-col">
      <div className="p-5 flex-1">
        <div className="flex items-start justify-between gap-3">
          <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${f.cor} flex items-center justify-center shadow-md shrink-0`}>
            <Icone className="w-6 h-6 text-white" strokeWidth={2} />
          </div>
          {estado}
        </div>
        <h2 className="font-bold text-lg mt-3">{f.titulo}</h2>
        <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{f.resumo}</p>
        <ul className="mt-3 space-y-1.5">
          {f.itens.map((i) => (
            <li key={i} className="flex items-start gap-2 text-xs text-muted-foreground">
              <Check className={`w-3.5 h-3.5 mt-0.5 shrink-0 ${f.disponivel ? "text-emerald-500" : "text-muted-foreground/50"}`} />{i}
            </li>
          ))}
        </ul>
      </div>
      <div className="flex items-center justify-between px-5 py-3 border-t bg-muted/20 text-sm font-semibold">
        <span className={f.disponivel ? "text-primary" : "text-muted-foreground"}>{f.disponivel ? "Abrir" : "Ver o que vem por aí"}</span>
        <ArrowRight className="w-4 h-4 text-muted-foreground group-hover:translate-x-0.5 transition-transform" />
      </div>
    </button>
  );
}

// IMPULSIONE SUAS VENDAS → Fidelize seu cliente: uma página central com as
// formas de fidelizar; cada card abre a página da ferramenta (v1.5.722).
export default function FidelizePage() {
  const navigate = useNavigate();
  const [cashback, setCashback] = useState(null);
  const [cartao, setCartao] = useState(null);

  useEffect(() => {
    axios.get("/api/cashback/config", auth()).then((r) => setCashback(r.data || {})).catch(() => setCashback({}));
    axios.get("/api/fidelidade/config", auth()).then((r) => setCartao(r.data || {})).catch(() => setCartao({}));
  }, []);

  const estadoDe = (f) => {
    if (!f.disponivel) {
      return <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-muted text-muted-foreground">Em breve</span>;
    }
    // Carregamento com cards (25/10/2026): o selo pisca até a situação chegar,
    // em vez de mostrar "Desligado" antes da hora.
    if ((f.id === "cashback" && cashback === null) || (f.id === "cartao" && cartao === null)) {
      return <Skeleton className="h-6 w-24 rounded-full" data-e2e="carregando-selo" />;
    }
    if (f.id === "cashback" && cashback?.ativo) {
      return (
        <span className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-1 rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" /> Ativo · {Number(cashback.percentual || 0)}%
        </span>
      );
    }
    if (f.id === "cartao" && cartao?.config?.ativo) {
      const abertos = cartao.situacao?.cartoes_abertos || 0;
      return (
        <span className="inline-flex items-center gap-1 text-[11px] font-bold px-2 py-1 rounded-full bg-emerald-500/15 text-emerald-600 dark:text-emerald-400">
          <span className="w-1.5 h-1.5 rounded-full bg-emerald-500 animate-pulse" /> Ativo · {abertos} {abertos === 1 ? "cartão" : "cartões"}
        </span>
      );
    }
    return <span className="text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-full bg-muted text-muted-foreground">Desligado</span>;
  };

  return (
    <div className="p-4 sm:p-6 lg:p-8" data-e2e="fidelize-hub">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-2xl bg-gradient-to-br from-rose-500 to-pink-600 flex items-center justify-center shadow-lg shadow-rose-500/30">
            <Heart className="w-5 h-5 text-white" strokeWidth={2.2} />
          </div>
          <div>
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight">Fidelize seu cliente</h1>
            <p className="text-muted-foreground text-sm">Cliente que volta custa menos que cliente novo. Escolha a forma de trazer ele de volta.</p>
          </div>
        </div>

        <div className="grid gap-4 sm:grid-cols-2">
          {FERRAMENTAS.map((f) => <Cartao key={f.id} f={f} estado={estadoDe(f)} aoAbrir={() => navigate(f.rota)} />)}
        </div>
      </div>
    </div>
  );
}
